module.exports = __webpack_public_path__ + "img/5859db863f3114bdac37209b6e3863e1.svg";